<script>
  import TextInput from '../../components/TextInput.svelte'
  import Button from '../../components/Button.svelte'
  import { notEmpty, isValidEmail } from '../../helpers/form-validation.js'
  import { clientStore, userStore, snackBarStore, tenantStore } from '../../state/store'
  import { isUserAdmin } from '../../helpers/utils'
  import { request } from '../../helpers/api'
  import { t } from '../../i18n/i18n'

  const form = {
    email: ''
  }

  $: formValid = isValidEmail(form.email)

  const submitForm = async () => {
    if (formValid && isUserAdmin($userStore)) {
      try {
        // Submit form data
        const response = await request({
          url: `/api/invite`,
          method: 'POST',
          body: JSON.stringify({
            ...form,
            tenant: $userStore.tenant_id,
            $userStore,
            origin: window.location.origin
          })
        })
        tenantStore.set(response)
        snackBarStore.set({ message: `${$t['Invitation sent to']} ${form.email.split()}`, type: 'success', selfDestruct: true })
        form.email = ""
      } catch (error) {
        snackBarStore.set({ message: error.message, type: 'error' })
      }
    }
  }
</script>

<form on:submit|preventDefault={submitForm}>
  <TextInput
    id='email'
    label='{$t.email}'
    validityMessage='{$t.valid_email}'
    on:input={event => (form.email = event.target.value)}
    value={form.email} />

  {#if $userStore.tier === 'pro'}
    <input type="checkbox" name='admin-user' id='admin-user' bind:checked={form.isAdmin}>
    <label for="admin-user">{$t.admin}</label>
  {/if}

  <Button size='full' type="submit" disabled={!formValid}>
    {$t.add_person}
  </Button>
</form>
